import React from "react";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoMdMail } from "react-icons/io";
import { ImProfile } from "react-icons/im";

const SocialIcons = () => {
  // const downloadFile = () => {
  //   const fileUrl = `${process.env.PUBLIC_URL}/Raman_Sharma.pdf`;

  //   fetch(fileUrl)
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.blob();
  //     })
  //     .then((blob) => {
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "Raman_Sharma.pdf");
  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode.removeChild(link);
  //     })
  //     .catch((error) => console.error("Error downloading the file:", error));
  // };
  const socialLinks = [
    {
      id: 1,
      child: (
        <>
          Linkedin <FaLinkedin className="text-teal-500" />
        </>
      ),
      href: "https://www.linkedin.com/in/iramansharma73/",
      style: "rounded-tr-up",
    },
    {
      id: 2,
      child: (
        <>
          Mail <IoMdMail className="text-teal-500" />
        </>
      ),
      href: "mailto:foo@gmail.com",
    },
    {
      id: 3,
      child: (
        <>
          WhatsApp <FaWhatsapp className="text-teal-500" />
        </>
      ),
      href: "https://www.linkedin.com/in/iramansharma73/",
    },

    {
      id: 4,
      child: (
        <>
          Resume <ImProfile className="text-teal-500" />
        </>
      ),
      href: "",
      style: "rounded-br-up",
      download: true,
    },
  ];
  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
      <ul>
        {socialLinks.map(({ id, child, href, style, download }) => (
          <li
            key={id}
            className={
              "flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-500" +
              " " +
              style
            }
          >
            <Link
              to={href}
              // onClick={downloadFile()}
              className="flex justify-between items-center w-full text-white"
              download={download}
              target="_blank"
            >
              {child}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialIcons;
